import debugLog from '@/debug-log-script-name.js'
import handleAjaxResponse from '@/components/handle-ajax-response.js'

$(function() {
  $('body').on('bless', function(e) {
    const $target = $(e.target)
    const $ajaxLinks = $target.is('[data-ajax-link]')
      ? $target
      : $target.find('[data-ajax-link]')
    debugLog($ajaxLinks, 'ajax-links.js')
    $ajaxLinks.on('click', function(e) {
      $.ajax({
        method: 'GET',
        url: $(this).attr('data-ajax-link'),
        dataType: 'json',
      }).done(function(data) {
        handleAjaxResponse(data)
      })

      e.preventDefault()
    })
  })
})
